import { gql } from '@apollo/client'
import type { UseMutationProps, UseMutationResult } from '@ztechapps/common.hook'
import { useMutation } from '@ztechapps/common.hook'
import type { ComputeBillingOfMaterialsArgs, Product } from '@ztechapps/common.contract'

const defaultQuery = gql`
  mutation computeBillingOfMaterials($input: ComputeBillingOfMaterialsArgs!) {
    computeBillingOfMaterials(input: $input) {
      _id
      fullBillOfMaterials
    }
  }
`

export type UseComputeBillingOfMaterialsResult = UseMutationResult<
  { computeBillingOfMaterials: Product },
  ComputeBillingOfMaterialsArgs
>

export const useComputeBillingOfMaterials = ({ query, ...props } = {} as UseMutationProps) => {
  query = query ?? defaultQuery

  return useMutation<{ computeBillingOfMaterials: Product }, ComputeBillingOfMaterialsArgs>({ query, ...props })
}
